export const COMMON = 'Something went wrong';
